"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchClick = void 0;
var linkClick_1 = require("./linkClick");
var searchClick = function (event) {
    var mainEventData = {
        event: "search-click",
        eventInfo: "search-click",
    };
    var linkEventData = (0, linkClick_1.linkClick)(event.eventData.searchClick.targetLinkTitle, event.eventData.searchClick.targetLinkModule || "coveo-title", event.eventData.searchClick.targetLinkURL);
    return [mainEventData, linkEventData];
};
exports.searchClick = searchClick;
